module.exports = __webpack_public_path__ + "static/media/sample_pdf.84652c9a.zip";